export default __webpack_public_path__ + "media/alarm_coldwind.f79eed5.mp3";